import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { PatientsPage } from './features/patients/PatientsPage';
import { PatientDetailPage } from './features/patients/PatientDetailPage';
import { AppointmentsPage } from './features/appointments/AppointmentsPage';
import { InvoicesPage } from './features/invoices/InvoicesPage';
import { InventoryPage } from './features/inventory/InventoryPage';
import { SettingsPage } from './features/settings/SettingsPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { AIDocumentationPage } from './features/ai/AIDocumentationPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { PublicBookingPage } from './pages/PublicBookingPage';

function AppContent() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/book/:clinicSlug" element={<PublicBookingPage />} />

      {/* Landing page - public */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="patients" element={<PatientsPage />} />
        <Route path="patients/:id" element={<PatientDetailPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="ai" element={<AIDocumentationPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
